export const SERVICE_SLUGS = [
  "executive-assistance",
  "personal-assistance",
  "executive-travel",
  "family-office-support",
  "global-partner-supplier-connections",
  "events-corporate-coordination",
  "research-problem-solving",
];

export const servicePages = {
  en: {
    "executive-assistance": {
      num: "01",
      title: "Executive Assistance",
      contactKey: "executive",
      headline: "Your day, engineered for focus.",
      intro: "Executive assistance that goes beyond administration: I protect your time, your priorities and your attention.",
      includes: [
        "Complex calendar & priority management",
        "Inbox, correspondence & filtering",
        "Meeting preparation & follow-up",
        "Day-to-day executive coordination",
        "Confidential handling of sensitive matters",
      ],
      experience:
        "Currently Executive Assistant to the President of a family office — previously EA to the CFO and PA to the CEO at Wallbox Chargers.",
      why: "Every hour you spend on administration is an hour you don't spend leading.",
    },
    "personal-assistance": {
      num: "02",
      title: "Personal Assistance",
      contactKey: "personal",
      headline: "Your private life, handled with the same rigour.",
      intro: "Discreet personal support that keeps everything outside the office running as smoothly as what happens inside it.",
      includes: [
        "Private appointments & commitments",
        "Personal & family logistics",
        "Confidential coordination",
        "Providers & household matters",
        "Personal and family travel",
      ],
      experience:
        "Years supporting presidents and CEOs across both professional and personal agendas — where the line between the two disappears.",
      why: "Peace of mind is knowing someone trustworthy owns the details you would otherwise carry yourself.",
    },
    "executive-travel": {
      num: "03",
      title: "Executive Travel & Itinerary Management",
      contactKey: "travel",
      headline: "I don't simply book travel. I manage the entire journey.",
      intro: "More than twenty years coordinating demanding executive and personal travel — complex international itineraries, multi-city journeys and schedules that never stand still.",
      includes: [
        "Complex international & multi-city itineraries",
        "Corporate, personal & family travel",
        "Last-minute changes, cancellations & rebooking",
        "Hotels, transfers & private drivers",
        "Coordination of multiple travelers",
        "Travel problem solving, whatever happens en route",
      ],
      experience:
        "From executive office management at a luxury resort in the Maldives to C-level travel at Wallbox — including itineraries rebuilt overnight.",
      why: "A CEO should be able to say: my itinerary has changed completely — and hear one answer: yes.",
      statement: "When plans change, I make the plan work.",
    },
    "family-office-support": {
      num: "04",
      title: "Family Office Support",
      contactKey: "familyoffice",
      headline: "Discreet support for the families behind the decisions.",
      intro: "Administrative and personal support for executives and families, with the confidentiality these environments demand.",
      includes: [
        "Administrative & personal support",
        "Coordination with external providers",
        "Documentation & follow-up",
        "Travel & logistics",
        "Absolute confidentiality",
      ],
      experience: "Current role: Executive Assistant to the President within a family office environment.",
      why: "A family office runs on trust. Everything I handle stays handled — and stays private.",
    },
    "global-partner-supplier-connections": {
      num: "05",
      title: "Global Partner & Supplier Connections",
      contactKey: "other",
      headline: "The right connection can open a door.",
      intro: "I help Spanish companies and agencies connect with international hotels, resorts, venues and specialist suppliers, acting as a professional point of contact between both sides.",
      includes: [
        "Source — identify relevant international suppliers and potential partners",
        "Connect — make the initial introduction and establish contact",
        "Coordinate — arrange video calls, meetings and presentations",
        "Facilitate — help both sides communicate efficiently and understand their needs",
        "Follow up — coordinate next steps and keep the conversation moving",
      ],
      experience:
        "An international network built over two decades across luxury hospitality in the Maldives, corporate events and executive environments.",
      why: "I make the right introductions happen.",
      disclaimer:
        "I facilitate introductions and help create new supplier and partnership opportunities; final approval as a supplier or partner always rests with each company.",
    },
    "events-corporate-coordination": {
      num: "06",
      title: "Events & Corporate Coordination",
      contactKey: "other",
      headline: "Events that run invisibly well.",
      intro: "From executive meetings to corporate conferences — orchestrated quietly, precisely and without drama.",
      includes: [
        "Executive meetings & conferences",
        "Corporate events",
        "Suppliers & venues",
        "Logistics & contingencies",
      ],
      experience:
        "Executive Assistant & Event Manager at Urbe Events — corporate events produced end to end.",
      why: "The best events are the ones where nobody notices the machinery.",
    },
    "research-problem-solving": {
      num: "07",
      title: "Research & Problem Solving",
      contactKey: "other",
      headline: "Answers before the question. Solutions before the problem.",
      intro: "When something needs solving, I find the way — and I own it until it is done.",
      includes: [
        "Research & clear options",
        "Provider sourcing & coordination",
        "Handling unexpected situations",
        "Ownership from start to finish",
      ],
      experience: "Two decades in environments where plans change constantly and someone has to make things work.",
      why: "You don't need to manage me. You need to trust me.",
    },
  },
  es: {
    "executive-assistance": {
      num: "01",
      title: "Asistencia Ejecutiva",
      contactKey: "executive",
      headline: "Tu día, diseñado para lo importante.",
      intro: "Asistencia ejecutiva que va más allá de la administración: protejo tu tiempo, tus prioridades y tu atención.",
      includes: [
        "Gestión de agenda compleja y prioridades",
        "Bandeja de entrada, correspondencia y filtrado",
        "Preparación de reuniones y seguimiento",
        "Coordinación ejecutiva del día a día",
        "Gestión confidencial de asuntos sensibles",
      ],
      experience:
        "Actualmente asistente ejecutiva del Presidente de un family office; anteriormente EA del CFO y PA del CEO en Wallbox Chargers.",
      why: "Cada hora que dedicas a la administración es una hora que no dedicas a liderar.",
    },
    "personal-assistance": {
      num: "02",
      title: "Asistencia Personal",
      contactKey: "personal",
      headline: "Tu vida privada, gestionada con el mismo rigor.",
      intro: "Soporte personal discreto para que todo lo que ocurre fuera de la oficina funcione tan bien como dentro.",
      includes: [
        "Citas y compromisos privados",
        "Logística personal y familiar",
        "Coordinación confidencial",
        "Proveedores y asuntos del hogar",
        "Viajes personales y familiares",
      ],
      experience:
        "Años apoyando a presidentes y CEOs en agendas profesionales y personales, donde la línea entre ambas desaparece.",
      why: "La tranquilidad es saber que alguien de confianza se ocupa de los detalles que de otro modo llevarías contigo.",
    },
    "executive-travel": {
      num: "03",
      title: "Viajes Ejecutivos y Gestión de Itinerarios",
      contactKey: "travel",
      headline: "No me limito a reservar viajes. Gestiono el viaje completo.",
      intro: "Más de veinte años coordinando viajes ejecutivos y personales exigentes: itinerarios internacionales complejos, viajes multiciudad y agendas que nunca se detienen.",
      includes: [
        "Itinerarios internacionales complejos y multiciudad",
        "Viajes corporativos, personales y familiares",
        "Cambios de última hora, cancelaciones y rebooking",
        "Hoteles, traslados y conductores privados",
        "Coordinación de varios viajeros",
        "Resolución de imprevistos en ruta",
      ],
      experience:
        "De la gestión de oficina ejecutiva en un resort de lujo en Maldivas a los viajes C-Level en Wallbox: incluidos itinerarios reconstruidos de un día para otro.",
      why: "Un CEO debería poder decir: mi itinerario ha cambiado por completo — y escuchar una única respuesta: sí.",
      statement: "Cuando los planes cambian, yo hago que el plan funcione.",
    },
    "family-office-support": {
      num: "04",
      title: "Soporte a Family Office",
      contactKey: "familyoffice",
      headline: "Soporte discreto para las familias detrás de las decisiones.",
      intro: "Soporte administrativo y personal para directivos y familias, con la confidencialidad que estos entornos exigen.",
      includes: [
        "Soporte administrativo y personal",
        "Coordinación con proveedores externos",
        "Documentación y seguimiento",
        "Viajes y logística",
        "Confidencialidad absoluta",
      ],
      experience: "Actualmente: asistente ejecutiva del Presidente en un entorno de family office.",
      why: "Un family office funciona sobre confianza. Todo lo que gestiono queda resuelto — y queda en privado.",
    },
    "global-partner-supplier-connections": {
      num: "05",
      title: "Conexiones Globales de Partners y Proveedores",
      contactKey: "other",
      headline: "La conexión adecuada puede abrir una puerta.",
      intro: "Ayudo a empresas y agencias españolas a conectar con hoteles, resorts, espacios y proveedores especializados internacionales, actuando como punto de contacto profesional entre ambas partes.",
      includes: [
        "Identificar — localizo proveedores internacionales relevantes y posibles partners",
        "Conectar — realizo la presentación inicial y establezco el contacto",
        "Coordinar — organizo videollamadas, reuniones y presentaciones",
        "Facilitar — ayudo a ambas partes a comunicarse y entender sus necesidades",
        "Seguimiento — coordino los próximos pasos y mantengo viva la conversación",
      ],
      experience:
        "Una red internacional construida durante dos décadas entre la hostelería de lujo en Maldivas, los eventos corporativos y los entornos ejecutivos.",
      why: "Yo hago que las conexiones adecuadas sucedan.",
      disclaimer:
        "Facilito presentaciones y ayudo a crear nuevas oportunidades de proveedores y partners; la aprobación final como proveedor o partner corresponde siempre a cada empresa.",
    },
    "events-corporate-coordination": {
      num: "06",
      title: "Eventos y Coordinación Corporativa",
      contactKey: "other",
      headline: "Eventos que funcionan de forma invisible.",
      intro: "De reuniones ejecutivas a conferencias corporativas: orquestados con precisión y sin drama.",
      includes: [
        "Reuniones ejecutivas y conferencias",
        "Eventos corporativos",
        "Proveedores y espacios",
        "Logística y contingencias",
      ],
      experience:
        "Asistente ejecutiva y event manager en Urbe Events: eventos corporativos producidos de principio a fin.",
      why: "Los mejores eventos son aquellos en los que nadie nota la maquinaria.",
    },
    "research-problem-solving": {
      num: "07",
      title: "Investigación y Soluciones",
      contactKey: "other",
      headline: "Respuestas antes de la pregunta. Soluciones antes del problema.",
      intro: "Cuando algo necesita solución, encuentro el camino — y me responsabilizo hasta que está hecho.",
      includes: [
        "Investigación y opciones claras",
        "Búsqueda y coordinación de proveedores",
        "Gestión de imprevistos",
        "Responsabilidad de principio a fin",
      ],
      experience: "Dos décadas en entornos donde los planes cambian constantemente y alguien tiene que hacer que funcionen.",
      why: "No necesitas gestionarme. Necesitas confiar en mí.",
    },
  },
};
